module.exports = "a {\n  color: white; }\n"